import { from } from "rxjs";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
export var pathNotEnoughResource = function (action$) {
    var missingResources = action$.missingResources;
    var filteredMissingResources = missingResources.missingResources.map(function (cost) {
        var missingResourceQuantity = cost.missing;
        return {
            amount: missingResourceQuantity,
            typeId: cost.resource.id,
        };
    });
    return from([
        actionOngoingPurchaseStandardSelect([
            {
                missingResources: filteredMissingResources,
                missingType: missingResources.resourceType,
            },
        ]),
        actionModalOpen(IdModal.NotEnoughResource),
    ]);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/expansions/paths/pathNotEnoughResource.ts
// module id = 2099
// module chunks = 3